import { RemoteGetAllCoursesByPerson } from 'data/usecases';
import { makeApiUrlCoursesByPerson } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllCoursesByPerson =
  (): RemoteGetAllCoursesByPerson => {
    return new RemoteGetAllCoursesByPerson(
      makeApiUrlCoursesByPerson(),
      makeAxiosHttpClient(),
    );
  };
